$shm_ba_summary_card $mol_view
	title \
	value \
	selected false
	attr *
		^
		shm_ba_summary_card_selected <= selected
	event *
		^
		click? <=> click? null
	sub /
		<= Title $mol_view
			sub /
				<= title
		<= Value $mol_view
			sub /
				<= value
